import { NUMBER_FORMAT } from '@chilecompra/react-kit'

import { ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_FORMAT } from '../../config/settings/regexes'
import { checkOnlyLettersNumbersAndSomeSymbols } from './checkers'

/**
 * Formats a monetary amount while typing, respecting the maximum
 * decimals allowed by the currency. Uses "." as thousands separator
 * and "," as decimal separator.
 */
export const formatAmountByCurrency = (value, maxDecimals = 0) => {
  let clean = String(value).replace(/[^\d,]/g, '')

  const firstComma = clean.indexOf(',')

  if (firstComma !== -1) {
    clean = `${clean.slice(0, firstComma + 1)}${clean.slice(firstComma + 1).replace(/,/g, '')}`
  }

  if (maxDecimals === 0) clean = clean.replace(/,/g, '')

  // eslint-disable-next-line prefer-const
  let [integer, decimal] = clean.split(',')

  integer = integer.replace(/^0+(?=\d)/, '').replace(NUMBER_FORMAT, '$1.')

  if (decimal !== undefined) {
    return `${integer},${decimal.substring(0, maxDecimals)}`
  }

  return integer
}

/**
 * Formats a given string value to only letters, numbers, and some symbols (._-,).
 */
export const formatOnlyLettersNumbersAndSomeSymbols = value =>
  checkOnlyLettersNumbersAndSomeSymbols(value)
    ? value
    : value.replace(ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_FORMAT, '')
